import { render } from "./DriversLicense.vue?vue&type=template&id=cdd2dee2&scoped=true"
import script from "./DriversLicense.vue?vue&type=script&lang=js"
export * from "./DriversLicense.vue?vue&type=script&lang=js"

import "./DriversLicense.vue?vue&type=style&index=0&id=cdd2dee2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd2dee2"]])

export default __exports__